import React from 'react';

export const TableCell = ({ variant = 'd', children }) => {
  if (variant === 'h') {
    return <th>{children}</th>;
  }

  return <td>{children}</td>;
};
